import React, { useState } from "react";
import ErrataDisplay from "/src/helpers/components/errataDisplay.jsx";
import CancelledStampOverlay from "/src/helpers/components/cancelledStampOverlay.jsx";

const HomepageTransferRow = ({ item }) => {
    const [expanded, setExpanded] = useState(false);
    const isCancelled = item?.cancelled === true;
    const transferDate = item.start ? new Date(item.start) : null;
    const isValidDate = transferDate && transferDate.getFullYear() > 1;
    const hasGuests = item.guests && item.guests.length > 0;
    const hasErratas = item.erratas && item.erratas.length > 0;

    const formatDate = (date) =>
        date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

    return (
        <div className={`relative rounded-card shadow-card ${(hasGuests || hasErratas) ? "px-8 pt-6 pb-2" : "px-8 py-6"} ${isCancelled ? "bg-red-50 border border-red-200" : "bg-white"}`}>
            {isCancelled && <CancelledStampOverlay />}
            <div className="flex flex-wrap items-center gap-2 mb-3">
                <div className="text-emp">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-[22px] w-[22px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
                    </svg>
                </div>
                <span className="text-sm font-semibold text-content_2 uppercase tracking-wide">Transfer</span>
                {item.vehicle && (
                    <span className="text-xs bg-emp_soft text-emp_dark font-medium px-2.5 py-1 rounded-full">{item.vehicle}</span>
                )}
                {isValidDate && (
                    <span className="text-sm text-content_2 ml-auto">{formatDate(transferDate)}</span>
                )}
                {item.extRef && (
                    <span className="text-xs font-medium text-content_2 basis-full">Supplier Ref: {item.extRef}</span>
                )}
            </div>

            <div className="flex flex-col sm:flex-row items-center sm:justify-center gap-3 sm:gap-3.5 mt-5 mb-4">
                {item.departureLocation && (
                    <p className="text-[17px] font-semibold text-primary text-center">{item.departureLocation}</p>
                )}

                {item.departureLocation && item.arrivalLocation && (
                    <>
                        {/* Desktop connector: dot — line — chevron — line — dot */}
                        <span className="hidden sm:inline-flex items-center shrink-0">
                            <span className="h-[11px] w-[11px] rounded-full bg-[#00AEEF]" />
                            <svg width="130" height="14" viewBox="0 0 130 14">
                                <line x1="2" y1="7" x2="56" y2="7" stroke="#c2cad4" strokeWidth="1.5" strokeLinecap="round" />
                                <polyline points="61 2.5 67 7 61 11.5" fill="none" stroke="#9aa6b4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <line x1="74" y1="7" x2="128" y2="7" stroke="#c2cad4" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            <span className="h-[11px] w-[11px] rounded-full bg-[#00AEEF]" />
                        </span>
                        {/* Mobile: down arrow between the stacked names */}
                        <svg xmlns="http://www.w3.org/2000/svg" className="sm:hidden h-5 w-5 text-content_3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14m0 0l-7-7m7 7l7-7" />
                        </svg>
                    </>
                )}

                {item.arrivalLocation && (
                    <p className="text-[17px] font-semibold text-primary text-center">{item.arrivalLocation}</p>
                )}
            </div>

            {hasErratas && (
                <div className="mt-3 pt-3 border-t border-content_5">
                    <ErrataDisplay erratas={item.erratas} />
                </div>
            )}

            {hasGuests && (
                <>
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="flex items-center gap-2 mt-3 pt-3 border-t border-content_5 w-full text-left cursor-pointer"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-content_3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <span className="text-sm font-medium text-content_2">{item.guests.length} Guest{item.guests.length !== 1 ? "s" : ""}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-4 w-4 text-content_3 ml-auto transition-transform duration-200 ${expanded ? "rotate-180" : ""}`}
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    {expanded && (
                        <div className="flex flex-wrap gap-2 mt-3">
                            {item.guests.map((guest, gIdx) => (
                                <div key={gIdx} className="flex items-center gap-2 text-sm text-content_1">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-content_3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    <span>{guest.title} {guest.firstname} {guest.lastname}</span>
                                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                                        guest.type === "Adult" ? "bg-emp_soft text-emp_dark" :
                                        guest.type === "Child" ? "bg-orange_light text-orange" :
                                        "bg-ocean-100 text-ocean-700"
                                    }`}>{guest.type}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default HomepageTransferRow;